import { ADS } from "./constants"

export const DEFAULT_PATH = "/22797863291/ca-pub-6877429655236920-tag/"

export const getFullPath = (path) => {
  return `${DEFAULT_PATH}${path}`
}

export const adStatuses = {}

export const REFRESH_INTERVAL = 30

export const getOrCreateStatus = (key) => {
  if (adStatuses[key]) {
    return adStatuses[key]
  }

  adStatuses[key] = {
    initialized: false,
    filled: false,
    activePath: ADS[key].path,
    slot: null,
  }
  return adStatuses[key]
}
